export function isShareableDocsLocation(
  pathname: string,
  search: string,
): boolean {
  const normalized = pathname.replace(/\/+$/, "");
  return (
    (normalized === "/apps/docs" || normalized === "/open/docs") &&
    new URLSearchParams(search).has("id")
  );
}
